<template>
  <div class="element-box">

    <div class="table-responsive mt-4">
      <table class="table table-striped">
        <thead>
        <tr>
          <th>{{ $t('general.date') }}</th>
          <th>{{ $t('general.start_location') }}</th>
          <th>{{ $t('general.end_location') }}</th>
          <th class="text-end">{{ $t('general.kilometer') }}</th>
          <th>{{ $t('general.reason') }}</th>
          <th v-if="travelExpenses.status === 'draft' || travelExpenses.status === 'modification'"
              class="text-end" style="padding-right: 40px;">{{ $t('general.actions') }}
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="item in items" :key="item.id">
          <td>{{ item.date }}</td>
          <td>{{ item.startLocation }}</td>
          <td>{{ item.endLocation }}</td>
          <td class="text-end">{{ item.distance }}</td>
          <td>{{ item.reason }}</td>
          <td class="text-end"></td>
        </tr>
        </tbody>
      </table>
    </div>

  </div>
</template>

<script setup>
import { defineProps, toRefs } from 'vue';

const props = defineProps({
  travelExpenses: {
    type: Object,
    required: false,
  },
  items: {
    type: Array,
    required: false,
  }
});

const { travelExpenses } = toRefs(props);
const { items } = toRefs(props);
</script>

<style scoped>

</style>